import { useMap } from "react-leaflet";
import { useEffect } from "react";
import * as L from "leaflet";
import { useTranslation } from "react-i18next";
import './ViewSwitchButton.css';
export const ViewSwitchButton = ({ onClick }) => {
    const { t } = useTranslation();
    const map = useMap();
    useEffect(() => {
        const customControl = new L.Control({ position: 'bottomleft' });
        customControl.onAdd = function () {
            const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control custom-button-control');
            const button = L.DomUtil.create('a', 'leaflet-control-layers-toggle', container);
            button.href = '#';
            button.title = t('viewSwitchButton.title');
            L.DomEvent.on(button, 'click', (e) => {
                L.DomEvent.stopPropagation(e);
                L.DomEvent.preventDefault(e);
                onClick();
            });
            return container;
        };
        customControl.addTo(map);
        return () => {
            customControl.remove();
        };
    }, [map]);
    return null;
};
